const AUTH_STORAGE_KEY = 'auth'
const HANDOFF_FLAG_KEY = 'op-auth-handoff'
const HANDOFF_PARAM = 'op-handoff'
const TENANT_PARAM = 'op-tid'

/** Marks a cross-origin jump. Tenant id is not a secret; the token stays in the cookie. */
export function buildHandoffUrl(baseUrl: string): string {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY)
    const tenantId: string | undefined = raw
      ? JSON.parse(raw)?.tenant?._id
      : undefined

    if (!tenantId) {
      return baseUrl
    }

    const url = new URL(baseUrl, window.location.origin)
    url.hash = new URLSearchParams({
      [HANDOFF_PARAM]: '1',
      [TENANT_PARAM]: tenantId,
    }).toString()

    return url.toString()
  } catch {
    return baseUrl
  }
}

/**
 * Drop the destination origin's stale auth before NgRx rehydrates.
 * Must run before bootstrapModule: ROOT_EFFECTS_INIT fires before APP_INITIALIZER.
 */
export function consumeAuthHandoff(): void {
  const params = new URLSearchParams(window.location.hash.replace(/^#/, ''))
  if (params.get(HANDOFF_PARAM) !== '1') {
    return
  }

  const tenantId = params.get(TENANT_PARAM)
  params.delete(HANDOFF_PARAM)
  params.delete(TENANT_PARAM)

  const rest = params.toString()
  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${window.location.search}${rest ? `#${rest}` : ''}`,
  )

  try {
    localStorage.removeItem(AUTH_STORAGE_KEY)
    tenantId && sessionStorage.setItem(HANDOFF_FLAG_KEY, tenantId)
  } catch {
    /* storage unavailable — login screen */
  }
}

export function consumeHandoffTenantId(): string | undefined {
  try {
    const tenantId = sessionStorage.getItem(HANDOFF_FLAG_KEY)
    tenantId && sessionStorage.removeItem(HANDOFF_FLAG_KEY)
    return tenantId || undefined
  } catch {
    return undefined
  }
}
